<template>
	<v-container class="d-flex flex-column align-start" fluid fill-height pa-0
		:class="this.$store.rdiStore.state.selectedType === 2 || this.$store.rdiStore.state.selectedType === 3 ? 'scrollable-list-bak':''">
		<FullHeader />
		<AdicionalesContainer />
	</v-container>
</template>

<script>
import FullHeader from '../../Globals/Headers/FullHeader'
import AdicionalesContainer from './AdicionalesContainer'

export default {
	name: 'AdicionalesIndex',
	components: {FullHeader, AdicionalesContainer},
	data: () => ({
		loading: false
	}),
	mounted(){
	},
	methods: {
	}
};
</script>


<style>
	.scrollable-list{
		flex: 1 1 auto;
		height: 100%;
	}
	.scrollable-list #consultas-container{
		flex: 1 1 auto;
		height: 100%;
	}
</style>